import Vue from "vue";
import Vuex from "vuex";
import _ from "lodash";
import createPersistedState from "vuex-persistedstate";
import modules from "./modules";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules,
  plugins: [createPersistedState({ reducer: ({ Autorizacoes, ...rest }) => rest })],
});

export default store;

export const limparDadosBasicos = () => {
  // Clear any basic active user modules if necessary
};

export const limparTodosOsDados = () => {
  store.commit("Franquias/setFranquias", []);
  store.commit("Roles/setRoles", []);
};
